import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FundraisingSummaryResponseNormalized } from '../../../../../../store/home/capture/types';

import { CheckingAccountItemDesktop } from './Desktop';
import { CheckingAccountItemMobile } from './Mobile';

export namespace CheckingAccountItemTypes {
  export type Props = {
    item: FundraisingSummaryResponseNormalized;
    onSelectAccount: (accountNumber: number) => void;
  };
}

export const CheckingAccountItem: React.FC<CheckingAccountItemTypes.Props> = (props) => {
  return useBreakpointValue({
    base: <CheckingAccountItemMobile {...props} />,
    sm: <CheckingAccountItemDesktop {...props} />,
  });
};
